interface SectionHeaderProps {
  kicker: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
}

export default function SectionHeader({
  kicker,
  title,
  desc,
  align = "left",
}: SectionHeaderProps) {
  const alignCls = align === "center" ? "text-center items-center mx-auto" : "text-left items-start";
  return (
    <div className={`flex flex-col ${alignCls} max-w-3xl mb-8 md:mb-10`}>
      <span className="inline-flex items-center gap-2 text-xs md:text-sm font-medium tracking-wide text-primary-600 mb-3">
        <i className="ri-arrow-right-line text-accent-500 text-sm w-4 h-4 flex items-center justify-center" />
        {kicker}
      </span>
      <h2 className="text-2xl md:text-4xl font-semibold text-foreground-950 leading-snug">
        {title}
      </h2>
      {desc ? (
        <p className="mt-4 text-sm md:text-base leading-7 text-foreground-600 max-w-2xl">
          {desc}
        </p>
      ) : null}
    </div>
  );
}